import { apiSlice } from '@services/apiSlice';
import { RelatedTabs as endpoints } from '@services/endpoints';
import { RelatedTabs } from './Related.types';

const requestedUrl = new URLSearchParams(window.location.search);
const hasQueryString = requestedUrl.get('model');

const relatedTabApi = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    fetchRelatedTabs: build.query<RelatedTabs, void>({
      query: () => ({
        url: endpoints.fetchRelatedTabs,
        params: {
          language: window.lang,
          pageId: window.pageId,
          isProductModelRequested: !!hasQueryString,
        },
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useFetchRelatedTabsQuery } = relatedTabApi;
